import React from "react";

export default function UpsOptions({
  shippingAddress,
  setShippingAddress,
  validateAddress,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  return (
    <>
      <div className="row mb-1">
        <div className="flex-center justify-content-start col-4 pe-0">
          <label className="form-label">Address Type</label>
        </div>
        <div className="col-8 d-flex align-items-center justify-content-between gap-2">
          <input
            value={shippingAddress?.addressType || ""}
            placeholder="Address Type"
            type="text"
            disabled
            className="form-control"
          />
        </div>
      </div>

      <div className="row mb-1">
        <div className="flex-center justify-content-start col-4 pe-0">
          <label className="form-label">Ground Transit Days</label>
        </div>
        <div className="col-8 d-flex align-items-center justify-content-between gap-2">
          <input
            value={shippingAddress?.addressGroundTransitDays || ""}
            onChange={(e) =>
              setShippingAddress({
                ...shippingAddress,
                addressGroundTransitDays: e.target.value,
              })
            }
            placeholder="Enter Ground Transit Days"
            type="number"
            className="form-control"
          />
        </div>
      </div>

      <div className="row mt-2">
        <button
          type="button"
          disabled={shippingAddress?.country?.toLowerCase() !== "us"}
          onClick={validateAddress}
          className="btn btn-info"
        >
          Validate
        </button>
      </div>
    </>
  );
}
